import type { PkPdMethodResult } from '../types';

const METHOD_RESULT_KEYS = new Set([
  'value',
  'pta',
  'target_min',
  'target_max',
  'target_met',
  'target_met_raw',
  'target_status',
  'unit',
  'details',
  'max_dose_exceeded',
  'is_optimal',
  'method',
]);

const isPlainObject = (value: unknown): value is Record<string, any> =>
  !!value && typeof value === 'object' && !Array.isArray(value);

export const isPkpdMethodResult = (value: unknown): value is PkPdMethodResult =>
  isPlainObject(value)
  && Object.keys(value).some((key) => METHOD_RESULT_KEYS.has(key));

export const normalizePkpdResults = (
  raw: unknown,
  preferredMethod?: string,
): Record<string, PkPdMethodResult> => {
  if (!isPlainObject(raw)) return {};

  if (isPkpdMethodResult(raw)) {
    return preferredMethod ? { [preferredMethod]: raw } : {};
  }

  const normalized: Record<string, PkPdMethodResult> = {};
  Object.entries(raw).forEach(([method, value]) => {
    if (isPkpdMethodResult(value)) {
      normalized[method] = value;
    }
  });

  if (preferredMethod) {
    const preferredResult = normalized[preferredMethod];
    return preferredResult ? { [preferredMethod]: preferredResult } : {};
  }

  return normalized;
};
